<template>
  <div class="cadastro-container">

    <div class="cadastro-left-container">
      <img :src="$config.images['avatar']" />
    </div>

    <div class="cadastro-right-container">
      <span v-html="$config.strings['home-whiteStrip']" />
    </div>

  </div>
</template>

<script>

export default {
  name: 'BarraAssinatura',
  data: () => ({}),
  computed: {
    images () {
      return {
        ASSINANTE_PREMIUM_BACKGROUND: this.$config.images['ASSINANTE_PREMIUM_BACKGROUND']
      }
    }
  },
  methods: {
    abrirDialogCadastro () {
      this.$refs.dialog.$refs.dialog.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-container {
  display: flex;
  flex-flow: row-reverse nowrap;
  justify-content: space-between;
  width: 100%;
  background-color: #ffffff;
  color: var(--on-secondary);
  padding: 0 3%;

  @include for-size(phone-only) {
    padding: 0 8%;
  }

  @include for-size(desktop-up) {
    flex-flow: row nowrap;
    padding: 0 10%;
  }

  .cadastro-left-container {
    position: relative;
    width: 33%;

    > img {
      position: absolute;
      bottom: 0;
      max-width: 100%;
      max-height:  325px;
    }

    @include for-size(phone-only) {
      > img {
        position: relative;
        left: 0;
        right: 0%;
        bottom: -15%;
        transform: initial;
      }
    }
  }

  .cadastro-right-container {
    position: relative;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    padding-right: 16px;
    font-size: 14px;
    color: var(--secondary-dark);
    width: 67%;

    @include for-size(tablet-portrait-up) {
      font-size: 24px;
      padding-right: 0;
      padding-left: 13px;
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }
}
</style>
